export const SET_PAGE_SEARCH_FORM = 'SET_PAGE_SEARCH_FORM' // 设置页面表单中的搜索数据
export const SET_COPY_INFO = 'SET_COPY_INFO' // 设置复制单据的信息